import { ElementType } from 'react';
import {
  FiActivity,
  FiAward,
  FiBarChart2,
  FiBriefcase,
  FiCalendar,
  FiClipboard,
  FiCpu,
  FiDatabase,
  FiDollarSign,
  FiDroplet,
  FiFileText,
  FiGlobe,
  FiHome,
  FiLayers,
  FiMapPin,
  FiPackage,
  FiPercent,
  FiPieChart,
  FiShoppingCart,
  FiSun,
  FiTarget,
  FiTool,
  FiTrendingUp,
  FiTruck,
  FiUsers,
  FiZap,
} from 'react-icons/fi';
import {
  TbBuildingBank,
  TbBuildingFactory2,
  TbBuildingStore,
  TbBuildingWarehouse,
  TbCalculator,
  TbClipboardCheck,
  TbDeviceDesktopAnalytics,
  TbEgg,
  TbGasStation,
  TbGrain,
  TbHeartHandshake,
  TbHelmet,
  TbMilk,
  TbPig,
  TbReportMoney,
  TbScale,
  TbSeeding,
  TbServer,
  TbTractor,
  TbWorld,
} from 'react-icons/tb';

// Cores do tema aceitas nos cards (mesma lista de BI_CARD_COLORS na API).
export const BI_COLORS: { key: string; label: string }[] = [
  { key: 'blue', label: 'Azul' },
  { key: 'cyan', label: 'Ciano' },
  { key: 'teal', label: 'Verde-água' },
  { key: 'green', label: 'Verde' },
  { key: 'yellow', label: 'Amarelo' },
  { key: 'orange', label: 'Laranja' },
  { key: 'red', label: 'Vermelho' },
  { key: 'pink', label: 'Rosa' },
  { key: 'purple', label: 'Roxo' },
  { key: 'gray', label: 'Cinza' },
];

export const BI_ICONS: { key: string; label: string; icon: ElementType }[] = [
  { key: 'bar-chart-2', label: 'Gráfico', icon: FiBarChart2 },
  { key: 'pie-chart', label: 'Pizza', icon: FiPieChart },
  { key: 'trending-up', label: 'Crescimento', icon: FiTrendingUp },
  { key: 'activity', label: 'Indicadores', icon: FiActivity },
  { key: 'dollar-sign', label: 'Financeiro', icon: FiDollarSign },
  { key: 'percent', label: 'Percentual', icon: FiPercent },
  { key: 'shopping-cart', label: 'Vendas', icon: FiShoppingCart },
  { key: 'package', label: 'Estoque', icon: FiPackage },
  { key: 'truck', label: 'Logística', icon: FiTruck },
  { key: 'users', label: 'Pessoas', icon: FiUsers },
  { key: 'briefcase', label: 'Administrativo', icon: FiBriefcase },
  { key: 'file-text', label: 'Documentos', icon: FiFileText },
  { key: 'clipboard', label: 'Auditoria', icon: FiClipboard },
  { key: 'layers', label: 'Camadas', icon: FiLayers },
  { key: 'database', label: 'Dados', icon: FiDatabase },
  { key: 'cpu', label: 'Tecnologia', icon: FiCpu },
  { key: 'tool', label: 'Manutenção', icon: FiTool },
  { key: 'zap', label: 'Energia', icon: FiZap },
  { key: 'sun', label: 'Campo', icon: FiSun },
  { key: 'droplet', label: 'Insumos', icon: FiDroplet },
  { key: 'home', label: 'Unidade', icon: FiHome },
  { key: 'map-pin', label: 'Filiais', icon: FiMapPin },
  { key: 'globe', label: 'Mercado externo', icon: FiGlobe },
  { key: 'calendar', label: 'Agenda', icon: FiCalendar },
  { key: 'target', label: 'Metas', icon: FiTarget },
  { key: 'award', label: 'Desempenho', icon: FiAward },
  // Áreas da cooperativa.
  { key: 'calculator', label: 'Contabilidade', icon: TbCalculator },
  { key: 'report-money', label: 'Controladoria', icon: TbReportMoney },
  { key: 'building-bank', label: 'Banco / Tesouraria', icon: TbBuildingBank },
  {
    key: 'clipboard-check',
    label: 'Auditoria / Qualidade',
    icon: TbClipboardCheck,
  },
  {
    key: 'building-warehouse',
    label: 'Suprimentos / Armazém',
    icon: TbBuildingWarehouse,
  },
  { key: 'building-store', label: 'Lojas / Varejo', icon: TbBuildingStore },
  {
    key: 'device-analytics',
    label: 'Tecnologia da informação',
    icon: TbDeviceDesktopAnalytics,
  },
  { key: 'server', label: 'Sistemas', icon: TbServer },
  { key: 'heart-handshake', label: 'Cooperados / RH', icon: TbHeartHandshake },
  { key: 'helmet', label: 'Segurança do trabalho', icon: TbHelmet },
  { key: 'grain', label: 'Cereais / Grãos', icon: TbGrain },
  { key: 'seeding', label: 'Agrícola / Sementes', icon: TbSeeding },
  { key: 'tractor', label: 'Máquinas agrícolas', icon: TbTractor },
  { key: 'factory', label: 'Fábrica de rações', icon: TbBuildingFactory2 },
  { key: 'pig', label: 'Suinocultura', icon: TbPig },
  { key: 'egg', label: 'Avicultura', icon: TbEgg },
  { key: 'milk', label: 'Leite', icon: TbMilk },
  { key: 'scale', label: 'Balança / Recebimento', icon: TbScale },
  { key: 'gas-station', label: 'Posto / Combustível', icon: TbGasStation },
  { key: 'world', label: 'Exportação / Internacional', icon: TbWorld },
];

// Ícone sugerido pelo nome do grupo (sem acento e sem diferenciar maiúsculas).
// A primeira regra que casar vence.
const ICON_SUGGESTIONS: [RegExp, string][] = [
  [/suin|porc/, 'pig'],
  [/avicult|frango|\bovos?\b/, 'egg'],
  [/leite|latic/, 'milk'],
  [/cerea|grao|graos|soja|milho|trigo/, 'grain'],
  [/racao|racoes|fabrica|industria/, 'factory'],
  [/agricol|lavoura|semente|insumo/, 'seeding'],
  [/maquina|mecaniza/, 'tractor'],
  [/contab/, 'calculator'],
  [/controlad/, 'report-money'],
  [/financ|tesour/, 'dollar-sign'],
  [/auditor|qualidade/, 'clipboard-check'],
  [/suprimento|compra|almox|estoque/, 'building-warehouse'],
  [/tecnologia|\bti\b|sistema/, 'device-analytics'],
  [/export|internacional|\bus\b|\busa\b/, 'world'],
  [/comerc|venda|sales/, 'shopping-cart'],
  [/loja|varejo|supermercado/, 'building-store'],
  [/logist|frota|transport/, 'truck'],
  [/recursos humanos|\brh\b|pessoa|gente|cooperado/, 'heart-handshake'],
  [/seguranca/, 'helmet'],
  [/energia/, 'zap'],
  [/posto|combust/, 'gas-station'],
  [/balanca|recebimento/, 'scale'],
  [/administr|diretoria/, 'briefcase'],
];

export function suggestIcon(groupName?: string | null): string | undefined {
  const name = (groupName || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

  return ICON_SUGGESTIONS.find(([pattern]) => pattern.test(name))?.[1];
}

export const BI_DEFAULT_COLOR = 'blue';
export const BI_DEFAULT_ICON = 'bar-chart-2';

export interface BiGroupStyle {
  name: string;
  color: string;
  icon: string;
  display_order: number;
}

export interface BiAppearance {
  color: string;
  icon: ElementType;
  iconKey: string;
}

function knownColor(color?: string | null): string | undefined {
  return color && BI_COLORS.some(item => item.key === color)
    ? color
    : undefined;
}

function knownIcon(icon?: string | null): string | undefined {
  return icon && BI_ICONS.some(item => item.key === icon) ? icon : undefined;
}

export function iconFor(key?: string | null): ElementType {
  return (BI_ICONS.find(item => item.key === key) || BI_ICONS[0]).icon;
}

// Aparência do card: a do relatório, senão a do grupo, senão o ícone sugerido
// pelo nome do grupo, senão a padrão.
export function resolveAppearance(
  report: { card_color?: string | null; card_icon?: string | null } | null,
  group?: Pick<BiGroupStyle, 'color' | 'icon'> | null,
  groupName?: string | null,
): BiAppearance {
  const color =
    knownColor(report?.card_color) ||
    knownColor(group?.color) ||
    BI_DEFAULT_COLOR;
  const iconKey =
    knownIcon(report?.card_icon) ||
    knownIcon(group?.icon) ||
    suggestIcon(groupName) ||
    BI_DEFAULT_ICON;

  return { color, iconKey, icon: iconFor(iconKey) };
}

type GroupStyles = Record<string, BiGroupStyle | undefined>;

// Ordem definida no admin e, empatando, o nome.
function compareGroups(styles: GroupStyles) {
  return (a: string, b: string) => {
    const orderA = styles[a]?.display_order ?? 0;
    const orderB = styles[b]?.display_order ?? 0;

    return orderA - orderB || a.localeCompare(b, 'pt-BR');
  };
}

export function sortGroupNames(names: string[], styles: GroupStyles): string[] {
  return [...names].sort(compareGroups(styles));
}

// Mesma ordem para as seções devolvidas por groupBiReports.
export function sortGroups<T extends { group: string }>(
  sections: T[],
  styles: GroupStyles,
): T[] {
  const compare = compareGroups(styles);

  return [...sections].sort((a, b) => compare(a.group, b.group));
}
